import { TNullableString } from './base';
import { IEventAtRead, IEventAtWrite } from './event';

export enum EContactType {
  PERSON = 'person',
  ORGANISATION = 'organisation'
}

export enum EContactRelationships {
  CHILD = 'child',
  SPOUSE = 'spouse',
  PARENT = 'parent',
  FRIEND = 'friend',
  ADVISOR = 'advisor',
  SIBLING = 'sibling',
  EXECUTOR = 'executor',
  EX_SPOUSE = 'ex-spouse',
  PET_GUARDIAN = 'pet_guardian',
  OTHER_FAMILY = 'other_family',
  GUARDIAN_OF_DEPENDENT = 'guardian_of_dependent'
}

export interface IContactWrite {
  name: string;
  type: EContactType;
  uid: TNullableString;
  email: TNullableString;
  photoURL: TNullableString;
  phoneNumber: TNullableString;
  isNotificationEmailSent: boolean;
  relationships: EContactRelationships[];
  notify?: boolean;
  created: IEventAtWrite;
  updated: IEventAtWrite;
}
export interface IContactRead extends IContactWrite {
  id: string;
  created: IEventAtRead;
  updated: IEventAtRead;
}

export interface IContactUniqueEmailWrite {
  id: string;
}
